// extracted by mini-css-extract-plugin
export var label = "_g8-2";
export var slideContainer = "_g8-0";
export var slider = "_g8-1";